import i from"styled-components";import{theme as e}from"../../../theme.js";const r=i.div`
  display: grid;
  grid-template-columns: repeat(5, ${({size:o})=>o}px);
  grid-column-gap: ${({gap:o})=>o}px;
`,t=i.div`
  width: 100%;
  height: ${({size:o})=>o}px;
  background-color: ${e.colors.gray[300]};
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  position: relative;
  > svg {
    width: 80%;
    height: 80%;
    position: relative;
    z-index: 2;
    > g, path {
      fill: ${e.colors.shades[0]};
    }
  }
  &.floatValue {
    ::after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      height: ${({size:o})=>o}px;
      width: ${({value:o})=>o}%;
      background-color: ${e.colors.primary[500]};
      z-index: 1;
      border-radius: 4px 0 0 4px;
    }
  }
  &.active {
    background-color: ${e.colors.primary[500]};
  }
`;export{r as Container,t as StarContainer};
